<template>
  <breadcrumb :title="title" :subTitle="subTitle" :link="link" />
  <div class="container">
    <div class="row">
        <Sidebar />
        <Reviews />
    </div>
  </div>
</template>

<script>
import breadcrumb from "@/components/layouts/breadcrumb.vue";
import Sidebar from '@/components/layouts/sidebar.vue';
import Reviews from '@/components/include/profile/reviews/product_reviews.vue';
export default {
  data() {
    return {
      title: this.$t("my_product_reviews"),
      subTitle: "",
      link: "",
    };
  },
  components: { breadcrumb, Sidebar, Reviews },
};
</script>

<style>
</style>